import type React from 'react';
import type { FC } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Loader } from '@crehana/ui';
import LazyLoad from '@crehana/web/Lazyload';
import Loadable from '@crehana/web/Loadable';

import type { PromoVideoProps } from './types';

const LazyPromoVideo: FC<React.PropsWithChildren<PromoVideoProps>> = props => (
  <LazyLoad
    style={{ width: '100%' }}
    placeholder={<div style={{ height: 302.06 }} />}
  >
    <Loadable
      module={() =>
        import(
          /* webpackChunkName: "admin-dashboard-news-promo-video" */
          './PromoVideo'
        )
      }
      Loader={<Loader />}
      {...props}
    />
  </LazyLoad>
);

export default LazyPromoVideo;
